import { useState } from "@wordpress/element";

// In your application's entrypoint
const { __ } = wp.i18n;
const { InnerBlocks, useBlockProps } = wp.blockEditor;
const { useSelect, dispatch } = wp.data;
const { Button, Placeholder, Modal } = wp.components;
const { useEffect } = wp.element;
const { registerBlockType } = wp.blocks;

registerBlockType("yt-player/parent", {
  title: __("Youtube Player Container", "ytp"),
  icon: "format-video",
  category: "media",
  keywords: [__("Youtube Player Container", "ytp"), __("Youtube Player", "ytp")],
  supports: {
    inserter: false,
    reusable: false,
    html: false,
  },

  edit: (props) => {
    const blockProps = useBlockProps();
    const { clientId, isSelected } = props;
    const innerBlocks = useSelect((select) => select("core/block-editor").getBlock(clientId).innerBlocks);
    const [notice, setNotice] = useState("");

    useEffect(() => {
      if (isSelected) {
        wp.data.dispatch("core/edit-post").openGeneralSidebar("edit-post/block");
      }
    }, [isSelected]);

    // make sure we don't check template validity because is's buggy as fuck
    dispatch("core/block-editor").setTemplateValidity(true);

    // don't add reusable videos to a reusable video

    const insertBlockType = (type) => {
      if (type === "carousel") {
        setNotice("");
      } else {
        const block = wp.blocks.createBlock(`yt-player/${type}`);
        return dispatch("core/block-editor").insertBlock(block, 0, clientId);
      }
    };

    const appenderToUse = () => {
      if (innerBlocks.length === 0) {
        return <InnerBlocks.ButtonBlockAppender />;
      } else {
        return false;
      }
    };

    if (!innerBlocks?.length) {
      return (
        <div>
          <div {...blockProps}>
            <Placeholder
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="html5-block-icon">
                  <polygon points="23 7 16 12 23 17 23 7"></polygon>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                </svg>
              }
              instructions={__("Choose a video type to get started.", "ytp")}
              label={__("Choose a Video Type", "ytp")}
            >
              <Button
                isPrimary
                onClick={() => {
                  insertBlockType("video");
                }}
              >
                {__("Single Video", "ytp")}
              </Button>
              <Button
                isPrimary
                onClick={() => {
                  insertBlockType("timeline");
                }}
              >
                {__("Timeline", "ytp")}
              </Button>
              <Button
                variant="primary"
                disabled={true}
                onClick={() => {
                  insertBlockType("carousel");
                }}
              >
                {__("Carousel", "ytp")}
              </Button>
            </Placeholder>
            <InnerBlocks templateLock={false} allowedBlocks={["yt-player/video", "yt-player/timeline", "yt-player/carousel"]} renderAppender={() => false} />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div {...blockProps}>
          <InnerBlocks templateLock={false} allowedBlocks={["yt-player/video", "yt-player/timeline", "yt-player/carousel"]} renderAppender={() => appenderToUse()} />
        </div>
      </div>
    );
  },

  save: () => {
    const blockProps = useBlockProps.save();
    return (
      <div {...blockProps}>
        <InnerBlocks.Content />
      </div>
    );
  },
});
